// removed by extract-text-webpack-plugin
module.exports = {"adjustmentMenu":"styles__adjustmentMenu__MEAZ9","adjustmentItem":"styles__adjustmentItem__2Eis4","subMenuContainer":"styles__subMenuContainer__3Ui6s","subMenuSubsection":"styles__subMenuSubsection__3Rs-y","subMenuOption":"styles__subMenuOption__2WVv1","filterOption":"styles__filterOption__1p5Oj","icon":"styles__icon__QkKgv","largeIcon":"styles__largeIcon__3PhRw","inlineIcon":"styles__inlineIcon__3URt7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AdjustmentMenu/styles.scss
// module id = 118
// module chunks = 0